import { useSyncExternalStore } from 'react'

function subscribe(notify: () => void) {
  window.addEventListener('online', notify)
  window.addEventListener('offline', notify)
  return () => {
    window.removeEventListener('online', notify)
    window.removeEventListener('offline', notify)
  }
}

export function ConnectionStatus() {
  const online = useSyncExternalStore(subscribe, () => navigator.onLine, () => true)
  if (online) return null
  return <aside className="connection-status" role="status">
    <strong>Você está sem conexão.</strong> O livro já aberto pode continuar disponível na memória.
    Não feche esta página: novos conteúdos e a sincronização precisam de internet.
  </aside>
}
